export const isValidLanguage = (lang) => {
  const supportedLanguages = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
  return supportedLanguages.includes(lang);
};

export const validateTranslations = (translations) => {
  const requiredKeys = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
  return requiredKeys.every(key => translations.hasOwnProperty(key));
};